namespace gotoAndPlay {
    let paged: number    = 1;
    let loading: boolean = false;

    function loadMoreArticles() {
        let exclude = [];
        $('.js-sticky-post').each(function() {
            if ($(this).data('id')) {
                exclude.push($(this).data('id'));
            }
        });
        $('.js-post-id').each(function() {
            if ($(this).val()) {
                exclude.push($(this).val());
            }
        });
        let data = {
            action: 'get_more_posts',
            posts_per_page: $('#posts-per-page') ? $('#posts-per-page').val() : null,
            paged: ++paged,
            category_id: $('#category-id').val() ? $('#category-id').val() : null,
            author: $('#author-id').val() ? $('#author-id').val() : null,
            tag: $('#tag-id').val() ? $('#tag-id').val() : null,
            search: $('#search-query').val() ? $('#search-query').val() : null,
            post__not_in: exclude.length > 0 ? exclude : null,
        };
        $.post(ajaxPath, data, function(response) {
            $('.js-article-grid__more-button').parent().replaceWith($(response['response_html']).html());
            loading = false;

            // Trigger videos
            $(document).trigger('enhance.video');
        });
    }

    $(document).on('click', '.js-article-grid__more-button', function() {
        loadMoreArticles();
    });

    //
    /*$(window).on('scroll', function() {
        if (!loading && $('.js-article-grid__more-button').length) {
            let screenBottom = $(window).scrollTop() + window.innerHeight;
            let buttonBottom = $('.js-article-grid__more-button').position().top - $('.article:last').height();
            if ((screenBottom > buttonBottom) && (paged > 1)) {
                loading = true;
                loadMoreArticles();
            }
        }
    });*/
}
